/* eslint-disable max-len */
import { memo } from 'react';

import { BUTTON_SIZES, BUTTON_TYPES, Button } from 'shared/components';
import { IconX } from 'shared/constants/icons.constants';
import { LANDING_URL } from 'shared/constants/url.constants';
import { withTranslation } from 'shared/helpers/i18n.helpers';
import { MessageData } from 'shared/modules/analyze/Scan/interfaces';

import styles from './styles.module.scss';

interface Props {
  detects: MessageData[]
}

function getRandomValueFromArray(arr: string[]): string {
  const randomIndex = Math.floor(Math.random() * arr.length);
  return arr[randomIndex];
}

const texts = [
  '🚨 Just got a heads-up from @web3_antivirus about a risky transaction. Always good to double-check before signing anything!',
  '@Web3_Antivirus just saved me from a high-risk transaction. 🛡️ Don’t let scammers win - protect your crypto as well!',
  '@Web3_Antivirus detected a high-risk transaction. My crypto is safe, is yours?',
  'Thanks to @Web3_Antivirus, I dodged a scam transaction! Ensure your crypto is safe with the best protection out there.',
];

const Share = ({ detects }: Props) => {
  const getLink = () => {
    const text = getRandomValueFromArray(texts);
    const twitterText = `${text} Encountered this on ${window.location.origin}`;

    const detectsParam = detects.filter(({ key }) => key).map(({ key }) => key).slice(0, 3).join(',');
    const link = `https://twitter.com/intent/tweet?text=${twitterText}&url=${encodeURIComponent(`${LANDING_URL}/report?detects=${detectsParam}`)}`;

    return link;
  };
  return (
    <div className={styles.wrap}>
      <a href={getLink()} target="_blank" rel="noopener noreferrer">
        <Button className={styles.btn} size={BUTTON_SIZES.XS} type={BUTTON_TYPES.SECONDARY}>
          <IconX />
          <span>Share</span>
        </Button>
      </a>
      <span className={styles.text}>{withTranslation('Notice community about the risks')}.</span>
    </div>
  );
};

export default memo(Share);
